import React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

/** replaces the toolbar while tracks are selected: Delete (unless they're all in Others already), New Character, Move To (or Merge Into) */
export default function SelectionBar({ countText, fromText, merging, canDelete, moveRef, onClear, onDelete, onNew, onMove, t }) {
  return (
    <div className="tk-selbar">
      <IconButton size="small" title={t("Clear selection")} aria-label={t("Clear selection")} onClick={onClear}>
        <CloseIcon />
      </IconButton>
      <div className="tk-selText">
        <b>{countText}</b>
        <span>
          {" · "}
          {fromText}
          {" · "}
          {t("drag them onto a character, or choose Move To")}
        </span>
      </div>
      {canDelete && (
        <Button className="Button ButtonXSmall" size="small" endIcon={<DeleteIcon />} onClick={onDelete}>
          {t("Delete")}
        </Button>
      )}
      {!merging && (
        <Button className="Button ButtonSecondary ButtonXSmall" size="small" endIcon={<PersonAddIcon />} onClick={onNew}>
          {t("New Character")}
        </Button>
      )}
      <Button ref={moveRef} className="Button ButtonPrimary ButtonXSmall" size="small" endIcon={<ArrowDropDownIcon />} onClick={onMove}>
        {merging ? t("Merge Into") : t("Move To")}
      </Button>
    </div>
  );
}
